import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  min-height: 100vh;
  background-color: white;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const AddOnSection = styled.section`
  display: flex;
  justify-content: flex-end;
  width: 50%;
  min-height: 100vh;
  padding: 72px 60px 24px 24px;

  @media (max-width: 1024px) {
    padding: 36px 24px 24px;
  }

  @media (max-width: 767px) {
    min-height: 0px;
    justify-content: center;
    width: 100%;
  }
`;

export const AddOnContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 346px;
`;

export const HomeLink = styled.a`
  margin-bottom: 47px;

  @media (max-width: 1024px) {
    margin-bottom: 32px;
  }
`;

export const AddOnCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 236px;
  max-width: 346px;
  border: 1px solid ${({ theme }) => theme.colors.gray[500]};
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2);
  padding: 24px;
`;

export const AddOnName = styled.h3`
  font-size: 24px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.suite[900]};
  text-align: center;
  margin-bottom: 12px;
`;

export const AddOnIcon = styled.div`
  width: 52px;
  margin-bottom: 5px;

  svg {
    fill: white;
  }
`;

export const AddOnTagline = styled.span`
  display: block;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 11px;
  color: ${({ theme, addOnKey }) =>
    theme.colors.utils.getByProductKey(addOnKey)};
`;

export const TrialStatement = styled.p`
  margin: 12px auto 0;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

export const TrialDetails = styled.div`
  margin-top: 24px;

  h3 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.suite[900]};
    margin-bottom: 6px;
  }

  p {
    font-family: "Circular";
    font-size: 13px;
    font-weight: 300;
    line-height: 22px;
    margin: 0;

    strong {
      font-weight: 500;
      color: ${({ theme }) => theme.colors.gray[700]};
    }
  }
`;

export const TrialHeading = styled.h1`
  ${({ theme }) => theme.heading["3"]};
  margin-bottom: 12px;
`;

export const PaymentSection = styled.section`
  width: 50%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray[200]};
  padding: 64px 24px 60px 90px;

  @media (max-width: 1024px) {
    padding: 76px 24px 60px;
  }

  @media (max-width: 767px) {
    width: 100%;
    min-height: 0px;
    justify-content: center;
    padding: 36px 24px 60px;
  }
`;

export const PaymentContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 300px;

  @media (max-width: 767px) {
    align-items: center;
    max-width: 100%;
  }
`;

export const FlashError = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.accent.red};
  border-radius: 3px;
  padding: 8px 16px;
  box-sizing: border-box;
  color: white;
  text-align: center;
  margin-top: 21px;
`;
